import { track } from '@bnnvara/analytics/src/track';
import { BaseButton } from '@bnnvara/buttons';
import { GridSpacer } from '@bnnvara/grids';
import { Heading, Text } from '@bnnvara/typography';
import Link from 'next/link';
import React from 'react';

import * as S from './styled';

export const DonationFailure = () => (
  <S.Wrapper align="center">
    <Heading element="h2" variant="two" textTransform="none" textAlign="center">
      Je betaling is mislukt
    </Heading>
    <GridSpacer />
    <Text center>
      Fijn dat je ons wilt steunen middels een donatie. Helaas is het niet
      gelukt om te doneren. Wil je het nogmaals proberen?
    </Text>
    <GridSpacer />
    <Link href="/donatie" passHref scroll={false}>
      <BaseButton
        fullWidth
        type="link"
        onClick={() =>
          track(' donatie-mislukt', 'click', 'terug-naar-donatieformulier')
        }
      >
        Terug naar het donatieformulier
      </BaseButton>
    </Link>
  </S.Wrapper>
);
